
define('text!src/api/indicators/res/indicator-template.html',[],function () { return '<div class="ls-indicator" title="">\n    <span class="label indicator-text"></span>\n</div>\n';});

